<template>
    <div id="social">
      <div class="container">
        <div class="section-title">
          شبــكات التواصـــل
        </div>
        <checkbox class="checkbox-filters" name="terms" v-for="item in filterItems" :key="item.id" :value="item" v-model="test">
          {{item}}<a href="#"></a>
        </checkbox>
        <ul>
          <li v-for="(insta,index) in filteredItems" :key="insta.id" v-if="index <= nSocial">
            <div class="tweet-image" :style="'background-image:url('+insta.image+')'"></div>
            <div class="content">
              <div class="date-type">
                <i :class="'fa '+insta.fontAwesome.toLowerCase()"></i>
                <div class="tweet-date">{{insta.date | moment("from", "now")}}</div>
              </div>
              <div class="tweet-date">{{insta.text | truncate(200) }}<a :href="insta.link" target="_blank"> إقرأ المزيد</a></div>
            </div>
          </li>
        </ul>
        <div class="load-more" v-if="loadMoreCheck" @click="loadMore">المزيد</div>
      </div>
    </div>
</template>

<script>
export default {
  data () {
      return {
        twitter:{},
        facebook:{},
        instagram:[],
        search:'',
        filterItems:['فيس بوك','انستغرام','تويتر'],
        loadMoreCheck:true,
        nSocial:8,
        test:[],
        windowWidth:''
      }
  },
  computed: {
    filteredItems: function () {
      var _this = this;
      var retVal = [];
      if(_this.test.length === 0){
        for (var i = 0; i < _this.instagram.length; i++) {
          retVal.push(_this.instagram[i])
        }
      }else{
        for (var i = 0; i < _this.instagram.length; i++) {
          _this.test.forEach(element => {
            if(_this.instagram[i].type === element){
              retVal.push(_this.instagram[i])
            }
          }); 
        }
      }
      return _.orderBy(retVal, 'date','desc')
    },
    getWindowWidth() {
        this.windowWidth = document.documentElement.clientWidth;
    },
    getnSocial(){
      if(this.windowWidth < 767){
        this.nSocial = 5
      } else{
        this.nSocial = 8
      }
    }
  },
  methods: {
    filteredPosts: function () {
      var self = this
      return self.instagram.filter(function (user) {
        return instagram.type.indexOf(self.searchQuery) !== -1
      })
    },
    loadMore(){
      this.nSocial = this.nSocial + 6
      if (this.instagram.length <= this.instagram ){
        this.loadMoreCheck = false
      }
    }
  },
  created () {
    this.$http.get('https://www.instagram.com/zaidounk/')
    .then(res => {
      
      
    })
    this.$http.get('https://www.instagram.com/zaidounk/')
    .then(result => {
      // return result.json()
      var data = JSON.parse(result.body.split("window._sharedData = ")[1].split(';<\/script>')[0]).entry_data.ProfilePage[0].graphql;
      console.log(data)
      let array = data.user.edge_owner_to_timeline_media.edges
      array.forEach(element => {
        let instagramPosts = {
          text: element.node.edge_media_to_caption.edges[0].node.text,
          date: element.node.taken_at_timestamp,
          image:element.node.thumbnail_src,
          link:'https://www.instagram.com/p/'+element.node.shortcode,
          type: 'انستغرام',
          fontAwesome: 'fa-instagram'
        }
        this.instagram.push(instagramPosts)
      });
    })
    .then(data => {
      // console.log(data.graphql.user.edge_owner_to_timeline_media.edges)
      
      
    })
    this.$http.get('https://cms.zaidounk.com/fbpost.php')
    .then(result => {
      return result.json()
    })
    .then(data => {
      for (let item in data) {
        let fbPosts = {
          text: data[item].message ? data[item].message : '',
          image: data[item].full_picture ? data[item].full_picture : '',
          date: data[item].created_time,
          link: data[item].link,
          type: 'فيس بوك',
          fontAwesome: 'fa-facebook'
        }
        this.instagram.push(fbPosts)
      }
    })
    .catch(error => {
      console.log(error)
    })
    this.$http.get('https://cms.zaidounk.com/tweets.php')
    .then(result => {
        return result.json()
    })
    .then(data => {
      for (let item in data) {
        let twitterTweets = {
          text: data[item].full_text,
          date: data[item].created_at,
          type: 'تويتر',
          fontAwesome: 'fa-twitter'
        }
        this.instagram.push(twitterTweets)
      }
    })
  },
  filters: {
    sortedItems() {
        this.instagram.sort( ( a, b) => {
            return new Date(a.date) - new Date(b.date);
        });
        return this.items;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sections/Social.vue